<div class="popup-container">
    <header class="header">
        <svg style="cursor:pointer" (click)="closePopup()" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 6.5L6.5 19.5" stroke="#FA1A1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.5 6.5L19.5 19.5" stroke="#FA1A1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg >
            
    </header>
    <content class="content">
        <div class="contentwrapper">
            <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M28.5 52.25C41.6168 52.25 52.25 41.6168 52.25 28.5C52.25 15.3832 41.6168 4.75 28.5 4.75C15.3832 4.75 4.75 15.3832 4.75 28.5C4.75 41.6168 15.3832 52.25 28.5 52.25Z" stroke="#FA1A1D" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M38 38C38 38 34.4375 33.25 28.5 33.25C22.5625 33.25 19 38 19 38" stroke="#FA1A1D" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21.375 21.375H21.3977" stroke="#FA1A1D" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M35.625 21.375H35.6477" stroke="#FA1A1D" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="message-wrapper">
                <p class="message">{{message()}}</p>
                <span class="submessage tiny-txt">{{submessage()}}</span>
            </div>

        </div>

            
    </content>
</div>